import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api, { track } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/shared";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/login");
        return;
      }
      try {
        const res = await api.post("/auth/google/session", { session_id: sessionId });
        if (res.data?.is_new_user) track("signup_completed", { method: "google" });
        // clear hash
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        navigate("/app/dashboard");
      } catch (e) {
        navigate("/login");
      }
    };
    run();
  }, [navigate, refresh]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <Spinner />
    </div>
  );
}
